<template>
    <ButtonPrimaryMd @click="handleSave" class="w-full" :disabled="disabled">
        <span> {{ disabled ? ctaDisabledLabel : ctaEnabledLabel }}</span>
        <CardShortcutPrimary v-if="!disabled"
            >{{ isOSSystem ? "⌘" : "Ctrl" }} ⇧ ⏎</CardShortcutPrimary
        >
    </ButtonPrimaryMd>
</template>

<script>
import { ButtonPrimaryMd } from "@easy/ui/buttons";
import { CardShortcutPrimary } from "@easy/ui/cards";
import { isOSSystem } from "@/shared/utils/helpers";

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        ctaEnabled: {
            type: String,
            default: "",
        },
        ctaDisabled: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            isOSSystem: isOSSystem(),
            justSaved: false,
        };
    },
    computed: {
        ctaEnabledLabel() {
            return this.justSaved
                ? this.$t("shared.just_saved")
                : this.ctaEnabled || this.$t("shared.save");
        },
        ctaDisabledLabel() {
            return this.justSaved
                ? this.$t("shared.just_saved")
                : this.ctaDisabled || this.$t("shared.saved");
        },
    },
    components: {
        ButtonPrimaryMd,
        CardShortcutPrimary,
    },
    emits: ["save"],

    mounted() {
        document.addEventListener("keydown", this.saveShortcut, false);
    },
    beforeUnmount() {
        document.removeEventListener("keydown", this.saveShortcut, false);
    },
    methods: {
        saveShortcut(e) {
            if (
                (e.metaKey && e.shiftKey && e.key === "Enter") ||
                (e.ctrlKey && e.shiftKey && e.key === "Enter")
            ) {
                this.$emit("save");
            }
        },
        handleSave() {
            this.$emit("save");
            this.justSaved = true;
            setTimeout(() => {
                this.justSaved = false;
            }, 2000);
        },
    },
};
</script>
